import root from 'window-or-global';
import { camelCaseKeys, rupees } from 'config/utils';
import * as CartActionTypes from 'actions/CartActions';
import {
  HANDLE_IP_CHANGE_INPUT,
  HANDLE_SET_TOTAL_AMOUNT,
} from 'payments/actions/InitializePurchaseActions';
import {
  HANDLE_CHANGE_RP_INPUT,
} from 'payments/actions/RefinePurchaseActions';

// exported for waggle
export function getInitialState () {
  const initialState = root.INITIAL_STATE;
  if (!initialState || (initialState && !Object.keys(initialState).length)) {
    return {};
  }

  const [username, slug] = initialState.offer.slug.split('/').filter(
    emptyString => emptyString
  );

  const { offer: o } = initialState;

  return {
    slug, username,
    offerPathname: o.slug,
    isImagePortrait: o.is_image_portrait,
    isOfferAvailable: o.is_available,
    errorCode: o.error_code,
    preview: o.preview,
    title: o.title,
    basePrice: o.base_price,
    minPrice: o.min_price,
    maxPrice: o.max_price,
    discount: camelCaseKeys({ ...initialState.discount }),
    priceBoost: o.price_boost,
    description: o.description,
    type: o.type,
    digital: camelCaseKeys({ ...o.digital }),
    event: camelCaseKeys({ ...o.event }),
    physical: camelCaseKeys({ ...o.physical }),
    isCarted: false,
    isBeingCarted: false,
    isCartable: o.is_cartable,
    isDirectCartable: o.is_direct_cartable,
    offerAffiliate: camelCaseKeys({ ...o.offer_affiliate }),
    addToCartErrors: {},
    limitQuantity: o.limit_quantity,
    purchasedQuantity: o.purchased_quantity,
  };
}

const offerInfo = (state = getInitialState(), action) => {
  switch (action.type) {
    case CartActionTypes.HANDLE_INIT_CART_ERROR:
      return {
        ...state,
        addToCartErrors: {
          All_: action.payload.error,
        },
      };

    case CartActionTypes.HANDLE_ADD_TO_CART_REQUEST:
      return {
        ...state,
        isBeingCarted: true,
        addToCartErrors: {},
      };
    case CartActionTypes.HANDLE_ADD_TO_CART_SUCCESS:
      return {
        ...state,
        isBeingCarted: false,
        isCarted: true, // able to do this right now as moving from one product to another is not push based.
      };
    case CartActionTypes.HANDLE_ADD_TO_CART_FAILURE:
      return {
        ...state,
        isBeingCarted: false,
        isCarted: false,
        addToCartErrors: action.errors || {},
      };

    case CartActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_SUCCESS: {
      const { slug } = action;
      if (slug === state.slug) {
        return {
          ...state,
          isCarted: false,
        };
      }
      return state;
    }

    case HANDLE_SET_TOTAL_AMOUNT: {
      const { totalAmount } = action.payload;
      let updateWith;
      if (totalAmount !== Math.round(totalAmount)) {
        updateWith = {
          ...state,
          totalAmount: totalAmount.toFixed(2),
        };
      }

      updateWith = {
        ...state,
        totalAmount,
      };

      return {
        ...updateWith,
        totalAmountFormatted: rupees(updateWith.totalAmount),
      };
    }

    case HANDLE_IP_CHANGE_INPUT:
    case HANDLE_CHANGE_RP_INPUT:
      return {
        ...state,
        isCarted: false,
      };

    default:
      return state;
  }
};

export default offerInfo;

export const getIsImagePortrait = state => state.isImagePortrait;

export const getIsOfferAvailable = state => state.isOfferAvailable;

export const getOfferErrorCode = state => state.errorCode;

export const getImagePreview = state => state.preview;

export const getOfferTitle = state => state.title;

export const getOfferSlug = state => state.slug;

export const getOfferPathname = state => state.offerPathname;

export const getOfferBasePrice = state => state.basePrice;

export const getOfferMinPrice = state => state.minPrice;

export const getOfferMaxPrice = state => state.maxPrice;

export const getOfferDiscount = state => state.discount;

export const getOfferPriceBoost = state => state.priceBoost;

export const getOfferDescription = state => state.description;

export const getOfferType = state => state.type;

export const getDigitalOfferInfo = state => state.digital;

export const getEventOfferInfo = state => state.event;

export const getPhysicalOfferInfo = state => state.physical;

export const getIsCartable = state => state.isCartable;

export const getIsDirectCartable = state => state.isDirectCartable;

export const getIsProductCarted = state => state.isCarted;

export const getIsProductBeingCarted = state => state.isBeingCarted;

export const getOfferAffiliate = state => state.offerAffiliate;

export const getAddToCartErrors = state => state.addToCartErrors;

export const getCartedAmount = state => state.totalAmount;

export const getCartedAmountFormatted = state => state.totalAmountFormatted;

export const getLimitQuantity = state => state.limitQuantity;

export const getPurchasedQuantity = state => state.purchasedQuantity;



// WEBPACK FOOTER //
// ./src/product/reducers/product/offerInfo.js